<template>
  <b-container fluid>
    <backlink />
    <h1>Locations agences</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="duration" slot-scope="{ data }">
        <b-badge variant="info">{{ data.value }}</b-badge>
      </template>
      <template slot="group_slug" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge
            v-if="data.value.includes('outillage')"
            variant="outillage"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-if="data.value.includes('instruments')"
            variant="instruments"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('instruments').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-if="data.value.includes('service_et_logistique')"
            variant="service_et_logistique"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "ReferenceList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      return {
        agency_number_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
      };
    },
  },
  mounted() {
    this.$store.dispatch("agency/getAllForSelect");
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "reference", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              statusSlug: "reference-en-location",
              agency: ctx.extended_filters_model.agency_number,
              business: ctx.extended_filters_model.business_number,
              user: ctx.extended_filters_model.user,
              group_slug: ctx.extended_filters_model.group_slug,
              startDate: ctx.extended_filters_model.last_location_date.start
                ? self
                    .$moment(ctx.extended_filters_model.last_location_date.start)
                    .format("YYYY-MM-DD")
                : null,
              endDate: ctx.extended_filters_model.last_location_date.end
                ? self
                    .$moment(ctx.extended_filters_model.last_location_date.end)
                    .format("YYYY-MM-DD")
                : null,
            },
          })
          .then((response) => {
            if (response.data.references) {
              response.data.references = response.data.references.map((reference) => ({
                ...reference,
                last_location_date:
                  reference.reference_logs &&
                  reference.reference_logs[0] &&
                  reference.reference_logs[0].start_date
                    ? reference.reference_logs[0].start_date
                    : null,
              }));
            }
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.references || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AgencyRentings/AgencyRentingsList.vue